import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Footer from "@/components/site/Footer";

export default function Impressum() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div
            data-testid="impressum-page"
            className="bg-background text-foreground min-h-screen"
        >
            <header className="border-b border-border/60">
                <div className="container-em py-6 flex items-center justify-between">
                    <Link
                        to="/"
                        data-testid="impressum-back-link"
                        className="inline-flex items-center gap-2 text-foreground/70 hover:text-foreground transition-colors"
                    >
                        <ArrowLeft size={16} /> Zur Startseite
                    </Link>
                    <span className="font-display text-2xl tracking-tight">
                        Emsglück<span className="text-primary">.</span>
                    </span>
                </div>
            </header>

            <main className="container-em py-16 md:py-24 max-w-3xl">
                <span className="font-accent text-xs uppercase tracking-[0.3em] text-primary">
                    Rechtliches
                </span>
                <h1 className="mt-4 font-display text-4xl md:text-5xl leading-tight tracking-tight">
                    Impressum
                </h1>

                <div className="mt-12 space-y-10 text-foreground/85 leading-relaxed">
                    <section>
                        <h2 className="font-display text-2xl text-foreground">
                            Angaben gemäß § 5 TMG
                        </h2>
                        <address className="mt-4 not-italic">
                            Jennifer Freimuth-Kröger
                            <br />
                            Wabenweg 31A
                            <br />
                            26125 Oldenburg
                            <br />
                            Deutschland
                        </address>
                    </section>

                    <section>
                        <h2 className="font-display text-2xl text-foreground">
                            Kontakt
                        </h2>
                        <p className="mt-4">
                            E-Mail:{" "}
                            <a
                                href="mailto:info@emsglueck.com"
                                className="text-primary hover:underline"
                            >
                                info@emsglueck.com
                            </a>
                        </p>
                    </section>

                    <section>
                        <h2 className="font-display text-2xl text-foreground">
                            Objektadresse
                        </h2>
                        <address className="mt-4 not-italic">
                            Ferienwohnung Emsglück
                            <br />
                            Borkumer Straße 29a
                            <br />
                            26871 Papenburg
                        </address>
                    </section>

                    <section>
                        <h2 className="font-display text-2xl text-foreground">
                            Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV
                        </h2>
                        <address className="mt-4 not-italic">
                            Jennifer Freimuth-Kröger
                            <br />
                            Wabenweg 31A
                            <br />
                            26125 Oldenburg
                        </address>
                    </section>

                    <section>
                        <h2 className="font-display text-2xl text-foreground">
                            Streitschlichtung
                        </h2>
                        <p className="mt-4">
                            Die Europäische Kommission stellt eine Plattform zur
                            Online-Streitbeilegung (OS) bereit:{" "}
                            <a
                                href="https://ec.europa.eu/consumers/odr"
                                target="_blank"
                                rel="noreferrer"
                                className="text-primary hover:underline break-all"
                            >
                                https://ec.europa.eu/consumers/odr
                            </a>
                            .
                        </p>
                        <p className="mt-3">
                            Wir sind nicht bereit oder verpflichtet, an
                            Streitbeilegungsverfahren vor einer
                            Verbraucherschlichtungsstelle teilzunehmen.
                        </p>
                    </section>

                    <section>
                        <h2 className="font-display text-2xl text-foreground">
                            Haftung für Inhalte
                        </h2>
                        <p className="mt-4">
                            Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG
                            für eigene Inhalte auf diesen Seiten nach den
                            allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis
                            10 TMG sind wir jedoch nicht verpflichtet,
                            übermittelte oder gespeicherte fremde Informationen
                            zu überwachen oder nach Umständen zu forschen, die
                            auf eine rechtswidrige Tätigkeit hinweisen.
                        </p>
                        <p className="mt-3">
                            Verpflichtungen zur Entfernung oder Sperrung der
                            Nutzung von Informationen nach den allgemeinen
                            Gesetzen bleiben hiervon unberührt. Eine
                            diesbezügliche Haftung ist jedoch erst ab dem
                            Zeitpunkt der Kenntnis einer konkreten
                            Rechtsverletzung möglich. Bei Bekanntwerden von
                            entsprechenden Rechtsverletzungen werden wir diese
                            Inhalte umgehend entfernen.
                        </p>
                    </section>

                    <section>
                        <h2 className="font-display text-2xl text-foreground">
                            Haftung für Links
                        </h2>
                        <p className="mt-4">
                            Unser Angebot enthält Links zu externen Websites
                            Dritter, auf deren Inhalte wir keinen Einfluss
                            haben. Deshalb können wir für diese fremden Inhalte
                            auch keine Gewähr übernehmen. Für die Inhalte der
                            verlinkten Seiten ist stets der jeweilige Anbieter
                            oder Betreiber der Seiten verantwortlich.
                        </p>
                    </section>

                    <section>
                        <h2 className="font-display text-2xl text-foreground">
                            Urheberrecht
                        </h2>
                        <p className="mt-4">
                            Die durch die Seitenbetreiber erstellten Inhalte
                            und Werke auf diesen Seiten unterliegen dem
                            deutschen Urheberrecht. Die Vervielfältigung,
                            Bearbeitung, Verbreitung und jede Art der
                            Verwertung außerhalb der Grenzen des Urheberrechtes
                            bedürfen der schriftlichen Zustimmung des
                            jeweiligen Autors bzw. Erstellers.
                        </p>
                    </section>
                </div>
            </main>

            <Footer />
        </div>
    );
}
